import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import DirectionsComponent from "./components/directions/DirectionsComponent.vue";
import store from "./store";
import QuizComponent from "./components/quiz/QuizComponent.vue";
const app = createApp(App);
app.component("madrid-directions", DirectionsComponent);
app.component("madrid-quiz", QuizComponent);
app.use(store).use(router).mount("#app");
